export default {
    methods: {
      getRandomInt(max){
        return Math.floor(Math.random() * Math.floor(max));
      },
      getXSubStr: function (string, limit) {
        if (string) return string.substring(0, limit) + "...";
        else return "";
      },
    }
}